import {
  Box,
  Button,
  FormControl,
  IconButton,
  Tabs,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { useTranslation } from "react-i18next";
import TabPanel from "../../../TabPanel";
import CommonGrid from "../../../Repository/CommonGrid";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../../redux/api";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { t } from "i18next";
import {eachDeep} from "deepdash-es/standalone";
import { treeActions } from "../../../../redux/slices/treeSlice";
import { cloneDeep, isArray } from "lodash";
import { getUpdatedData } from "../../../RightContextMenu/ContextActions/NewRecord";
import { genKey } from "../../../../utils/utilFunctions";
import ConfirmModal from "../FieldDataValidation/ConfirmModal";
import { lgDocPath } from "../../../../constants/languageDocPaths";
import { Loader } from "../../../../utils/loader";
import LightTooltip from "../../../../commonComponents/LightTooltip";

const columnDefNameMaping = {
  name: t("DB_NAV_COLUMN_NAME"),
  dataType: t("DB_NAV_COLUMN_TYPE"),
  columnSize: t("DB_NAV_COLUMN_LENGTH"),
  isNullable: t("DB_NAV_COLUMN_NULLABLE"),
  typeName: t("DB_NAV_COLUMN_NATIVE_TYPE"),
  remarks: t("DB_NAV_COLUMN_REMARKS"),
};

const compareSQLColumnDefs = [
  {
    headerName: '',
    field: 'checked',
    checkboxSelection : true,
    width: 10,
  },
  {
    headerName: t('ACTION'),
    editable: false,
    field: 'action',
    resizable: true
  },
  {
    headerName: t('DB_NAV_COLUMN_FIELD'),
    editable: false,
    field: 'column',
    resizable: true
  },
  {
    headerName: t('DB_NAV_COLUMN_MESSAGE'),
    editable: false,
    field: 'message',
    resizable: true
  }
] 


const DatabaseNavigatorRightBottom = ({
  connection,
  setConnection,
  encoding,
  setEncoding,
  schema,
  setSchema,
  selectedTable,
  setSelectedTable,
  sort,
  setSort,
  sqlQuery,
  setSqlQuery,
  sqlActions,
  setSqlActions,
  currTab,
  setCurrTab,
  selectedMetaData,
  setSelectedMetaData,
  setCurrTabTop,
  templateQuery,
  prepend,
  setPrepend,
  selectedCompareSQL,
  setSelectedCompareSQL,
  setConnectionLoading,
  showAlert
}) => {
  const { t } = useTranslation();
  const [sqlResultGridApi, setSqlResultGridAPI] = useState()
  const [compareSqlGridAPI, setCompareSQLGridAPI] = useState()
  const [confirmModal, setConfirmModal] = useState(false);
  const [uncheckAll, setUncheckAll] = useState(true);
  const [parseResult, setParseResult] = useState('');
  const [rowData, setRowData] = useState({
    metaData: [],
    top25: [],
    sqlResult: [],
    compareSQL: [],
  });
  const [gridOptions, setGridOptions] = useState({
    metaData: {},
    top25: {},
    sqlResult: {},
    compareSQL: {
      columnDefs: compareSQLColumnDefs
    },
  });
  const [previousSelectedTable, setPreviousSelectedTable] = useState({
    metaData: '',
    top25: '',
  });
  const [error, setError] = useState({
    sqlResult: '',
  });
  const timestamp = Date.now();
  const dispatch = useDispatch();
  const queryParams = useSelector((state) => state.queryParams);
  const parentScreen = useContext(ParentScreenCtx);
  const docpath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/screens/inbound/databaseNavigator.html?timestamp=${timestamp}`;
  const rightTree = useSelector((state) => state?.treeData?.[parentScreen]?.rightTree);
  const selectedNode = rightTree?.tree?.[rightTree?.currentTab]?.selectedNode;
  const translatedData = rightTree.tree[rightTree?.currentTab].translatedData;
  const metaLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["META_LOADING"]?.isLoading || false) 
  const top25Loading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["TOP25_LOADING"]?.isLoading || false) 
  const sqlLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SQL_LOADING"]?.isLoading || false) 
  const compareLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["COMPARE_LOADING"]?.isLoading || false) 
  const metaError = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["META_LOADING"]?.isError || false) 
  const top25Error = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["TOP25_LOADING"]?.isError || false) 
  const sqlError = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SQL_LOADING"]?.isError || false) 
  const compareError = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["COMPARE_LOADING"]?.isError || false) 
  

  const metaTimer = useRef();
  const top25Timer = useRef();
  const sqlTimer = useRef();
  const compareTimer = useRef();


  const nothingToDisplay = useMemo(() => {
    return <div style={{
      width: '100%', 
      height: '100%', 
      fontSize: '16px', 
      color: '#b5b2ba',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    } }>{t("TRACKING_REPORTS_NOTHING_TO_DISPLAY")}</div>
  })

  const handleTabChange = (e, newValue) => {
    setCurrTab(newValue);
  };

  const metaGridSelectionHandler = (gridOptions) => {
    const selectedRows = gridOptions.api.getSelectedRows();
    if (selectedRows.length > 0) {
      setSelectedMetaData(selectedRows);
    } else {
      setSelectedMetaData([]);
    }
  }

  const compareSqlSelectHandler = (gridOptions) => {
    const selectedRows = gridOptions.api.getSelectedRows();
    if (selectedRows.length > 0) {
      setSelectedCompareSQL(selectedRows);
    } else {
      // setSelectedMetaData([]);
    }
  }

  const onRowDataUpdated = (gridOptions) => {
    selectedMetaData?.forEach(e => {
      gridOptions.api.forEachNode(node => {
        if(node?.data?.name === e?.name){
          node.setSelected(true);
        }
      })
    })
  };

  const rowDataUpdatedCompareSQL = (gridOptions) => {
      gridOptions.api.forEachNode(node => {
        node.setSelected(true);
      })
      setUncheckAll(true);
  };


  const uncheckAllHandler = (uncheckAll) => {
    if (compareSqlGridAPI){
      compareSqlGridAPI.api.forEachNode( node => {
        node.setSelected(uncheckAll ?  false : true);
      })
    }
    setUncheckAll(!uncheckAll);
  }

  const handleUpdate = () => {
    const deletedNodes = selectedCompareSQL?.filter( e => e.action === "Delete") || [] ;
    let addNodes = selectedCompareSQL?.filter( e => e.action === "Add")
    addNodes = addNodes?.map( (e, i) => {
      const tableName = e?.column?.split('.')?.[0]
      const columnName = e?.column?.split('.')?.[1];
      return {
        "COLUMN_NAME" : columnName, 
        "DESCRIPTION" : columnName, 
        "FIELDTYPE" : "ALPHA", 
        "ICON_DISPLAY" : "DATABASE_FIELD", 
        "MAPNAME" : columnName, 
        "TABLE_NAME" : tableName,
        "title" : `${t("LBL_FIELD")} ${columnName}`,
        "key" : selectedNode?.key+`-${i}`,
        "nodeId" : genKey()
      }
    }) || [] ;
    const newTranslatedData = cloneDeep(translatedData);
    eachDeep(newTranslatedData, (obj) => {
      if(obj?.key && obj?.key === selectedNode?.key) {
        let children = [...(obj?.children || [])];
        // Deleting Nodes according to api response in Compare SQL
        for (let i = 0 ; i < deletedNodes?.length; i++){
          for(let j = 0; j < children.length; j++) {
            const tableName = children?.[j]?.TABLE_NAME;
            const columnName = children?.[j]?.COLUMN_NAME;
            const deleteTableName = deletedNodes?.[i]?.column?.split('.')?.[0]
            const deleteColumnName = deletedNodes?.[i]?.column?.split('.')?.[1];
            if (tableName === deleteTableName && columnName === deleteColumnName){
              children.splice(j,1);
              break;
            }
          }
        }
        obj.children = [...addNodes, ...children];
        dispatch(treeActions.setRightTreeTransData({
          screen: parentScreen,
          type: rightTree?.currentTab,
          data: obj
        }))
      }
    })
    dispatch(treeActions.setNewRightTreeTranslatedData({
      screen: parentScreen,
      type: rightTree?.currentTab,
      data: getUpdatedData(newTranslatedData, "DATABASE")
    }))
    setCurrTabTop(0);
    setCurrTab(0);
  }

  const addFieldshandler = () => {
    dispatch(treeActions.setTreeActions({
      data: {
        treeType: rightTree.currentTab,
        expandKeys: [selectedNode?.key]
      },
    }))
    const selectedNodeKey = selectedNode?.key;
    const newNodes = [];

    // Making New Nodes to Add
    selectedMetaData?.forEach(( e, i )=>{
      newNodes.push({
        "COLUMN_NAME" : e.name, 
        "DESCRIPTION" : e.name, 
        "FIELDTYPE" : e.dataType, 
        "ICON_DISPLAY" : "DATABASE_FIELD", 
        "MAPNAME" : e.name, 
        "TABLE_NAME" : prepend ? schema + "." + selectedTable : selectedTable,
        "title" : `${t("LBL_FIELD")} ${e.name}`,
        "key" : selectedNodeKey+`-${i}`,
        "nodeId" : genKey()
      })
    })

    const newTranslatedData = cloneDeep(translatedData);
    eachDeep(newTranslatedData, (obj) => {
      if(obj?.key && obj?.key === selectedNodeKey){
        obj.children = [...newNodes, ...(obj?.children || [])]
        dispatch(treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: rightTree?.currentTab,
          data: obj
        }))
      }
    })

    dispatch(treeActions.setRightTreeTransData({
      screen: parentScreen,
      type: rightTree?.currentTab,
      data: getUpdatedData(newTranslatedData, "DATABASE")
    }))
    setCurrTabTop(0);

  }

  // This Function is keeping only those columns in AG-grid which has atleast one value to show in that coloumn;
  const updateNewGridOptionsMeta = (data, type) => {
    const columnDefs = []
    Object.keys(columnDefNameMaping).forEach( e => {
      for (let i = 0; i < data.length ; i++) {
        const ele = data[i];
        if (ele[e]) {
          columnDefs.push({
            headerName: columnDefNameMaping[e],
            field: e,
            resizable: true,
            editable: false,
            showPlaceholder: false
          })
          break;
        }
      }
    })
    setGridOptions(prev => { return {...prev, metaData: {columnDefs}}}) ;
  }

  const updateNewGridOptionsGeneric = (data = [], rowData = [], type) => {
    const columnDefs = [];
    for (let i = 0; i<data.length ;i++) {
      for (let j = 0 ; j < rowData.length ; j++){
        if (rowData?.[j]?.[i]) {
          columnDefs.push({
            headerName: data[i],
            field: data[i],
            resizable: true,
            editable: false,
            showPlaceholder: false
          })
          break;
        }
      }
    }
    setGridOptions(prev => { return {...prev, [type]: {columnDefs}}}) ;
  }

  useEffect(() => {
    if (sqlResultGridApi && sqlResultGridApi.api.setColumnDefs) {
      sqlResultGridApi.api.setColumnDefs(gridOptions?.sqlResult?.columnDefs || []);
    }
  },[gridOptions, sqlResultGridApi])

  const updateMetaDataHandler = (sort) => {
    if (!selectedTable || !schema || (previousSelectedTable.metaData === (schema+"."+selectedTable)) && sort === undefined) return;
    if (metaTimer.current) clearTimeout(metaTimer.current);
    dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "META_LOADING", data: {isLoading: true, isError: false}}));
    dispatch(
      api.endpoints.get_metadata.initiate(
        {
          account: queryParams.account,
          direction: parentScreen === "inbound" ? "IN" : "OUT",
          table_name: selectedTable,
          pdc_name: connection,
          sort: sort || false,
          schema: schema,
        },
        { forceRefetch: true}
      )
    ).then((res) => {
      if (res?.data?.current_state === "SUCCESS" && isArray(res?.data?.data)) {
        let rowData = [...res?.data?.data || []];
        updateNewGridOptionsMeta(rowData);
        if (sort) rowData = rowData.sort((a, b) => a?.name?.localeCompare(b?.name))
        setRowData(prev => { return {...prev, metaData: rowData} })
        setPreviousSelectedTable( prev => {return {...prev, metaData:schema+"."+selectedTable }})
      }
      else {
        const message = (!isArray(res?.data?.data) && res?.data?.data) ? res?.data?.data : res?.data?.message;
        showAlert({ mssg: message, isOpen: true, type: 'warning' });
      }
    })
    // metaTimer.current = setTimeout(() => {
    //     dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "META_LOADING", data: {isError: true}}));
    // }, 120000)
  };

  const updateTop25DataHandler = (sort) => {
    if (!selectedTable || !schema || (previousSelectedTable.top25 === (schema+"."+selectedTable)) && sort === undefined) return;
    if(top25Timer.current) clearTimeout(top25Timer.current);
    dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "TOP25_LOADING", data: {isLoading: true, isError: false}}));
    dispatch(
      api.endpoints.get_top_25_records.initiate(
        {
          account: queryParams.account,
          direction: parentScreen === "inbound" ? "IN" : "OUT",
          table_name: selectedTable,
          pdc_name: connection,
          encoding: encoding,
          schema: schema,
        },
        { forceRefetch: true }
      )
    ).then((res) => {
      if (res?.data?.current_state === "SUCCESS" && isArray(res?.data?.data)) {
        const rowData = [...res?.data?.data || []];
        const headers = rowData.splice(0,1)[0];
        if (rowData[0] && !rowData?.[0]?.[0]?.includes(t('LBL_NO_RECORDS'))){
          updateNewGridOptionsGeneric(headers,rowData,"top25");
          const newRowData = rowData.map(e => {
            const ele = {}
            for (let i = 0; i < e.length; i++){
              ele[headers[i]] = e[i];
            }
            return ele;
          })
          setRowData(prev => { return {...prev, top25: newRowData} })
        }
        setPreviousSelectedTable( prev => {return {...prev, top25:schema+"."+selectedTable }})
      }
      else {
        const message = (!isArray(res?.data?.data) && res?.data?.data) ? res?.data?.data : res?.data?.message;
        showAlert({ mssg: message, isOpen: true, type: 'warning' });
      }
    })
    // top25Timer.current = setTimeout(() => {
    //     dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "TOP25_LOADING", data: {isError: true}}));
    // }, 120000)
  };

  const runSqlScript = (type) => {
    if (sqlTimer.current) clearTimeout(sqlTimer.current);
    dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SQL_LOADING", data: {isLoading: true, isError: false}}));
    dispatch(api.endpoints.get_sql_result.initiate({
      account: queryParams.account, 
      direction: parentScreen === "inbound" ? "IN" : "OUT", 
      pdc_name: connection, 
      encoding: encoding, 
      schema: schema, 
      body: {
        sqlQueryToRun : type === "runTemplateScript" ? templateQuery : sqlQuery
      }
    },{forceRefetch: true}))
    .then (res => {
      setConnectionLoading(false);
      if (res?.data?.current_state === "SUCCESS") {
        const rowData = [...res?.data?.data || []];
        const headers = rowData.splice(0,1)[0];
        if (rowData[0] && rowData?.length && isArray(res?.data?.data?.[0]) && isArray(res?.data?.data?.[1])){
          updateNewGridOptionsGeneric(headers,rowData,"sqlResult");
          const newRowData = rowData.map(e => {
            const ele = {}
            for (let i = 0; i < e.length; i++){
              ele[headers[i]] = e[i];
            }
            return ele;
          })
          setError(prev => { return {
            sqlResult: ''
          }})
          setRowData(prev => { return {...prev, sqlResult: newRowData} })
        }else {
          let errorArray; 
          if (isArray(res?.data?.data?.[0])){
            const [first, ...restArray] = res?.data?.data || [];
            errorArray = restArray;
          }else {
            errorArray = res?.data?.data || []
          }
          const error = errorArray.map(e => {
            return <div>{e}</div>;
          })
          setError({
            sqlResult : error
          })
        }
      }
      else {
        showAlert({ mssg: res?.data?.message, isOpen: true, type: 'warning' });
      }
    })
    setSqlActions({
      runTemplateScriptHandler: false,
      runSqlScript: false
    })
    // sqlTimer.current = setTimeout(() => {
    //     dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SQL_LOADING", data: {isError: true}}));
    // }, 120000)
  }

  const runCompareSql = () =>{
    setRowData(prev => { return {...prev, compareSQL: []} })
    if (compareTimer.current) clearTimeout(compareTimer.current);
    setCurrTab(3);
    dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading: true, isError: false}}));
    setError(prev =>  {
    return {
      ...prev,
      compareSQLTemp : '',
      compareSQL: ''
    }})
    dispatch(api.endpoints.get_sql_result.initiate({
      account: queryParams.account, 
      direction: parentScreen === "inbound" ? "IN" : "OUT", 
      pdc_name: connection, 
      encoding: encoding, 
      schema: schema, 
      body: {
        sqlQueryToRun : templateQuery
      }
    },{forceRefetch: true}))
    .then ((res) => {
      if (res?.data?.current_state === "SUCCESS") {
        const rowData = [...res?.data?.data || []];
        if (!rowData[0] || !rowData?.length || !isArray(res?.data?.data?.[0]) || (res?.data?.data?.[1] && !isArray(res?.data?.data?.[1]))){
          let errorArray; 
          if (isArray(res?.data?.data?.[0])){
            const [first, ...restArray] = res?.data?.data || [];
            errorArray = restArray;
          }else {
            errorArray = res?.data?.data || []
          }
          const error = errorArray.map(e => {
            return <div>{e}</div>;
          })
          setError(prev =>  {return {
            ...prev,
            compareSQLTemp : error?.length ? error : ''
          }})
          if (error?.length) setConfirmModal(true);
          dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading:false, isError: false}}));   
        }else {
          dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading: true, isError: false}}));
          dispatch(api.endpoints.get_sql_result.initiate({
            account: queryParams.account, 
            direction: parentScreen === "inbound" ? "IN" : "OUT", 
            pdc_name: connection, 
            encoding: encoding, 
            schema: schema, 
            body: {
              sqlQueryToRun : sqlQuery
            }
          },{forceRefetch: true}))
          .then ((res) => {
            if (res?.data?.current_state === "SUCCESS") {
              const rowData = [...res?.data?.data || []];
              if (!rowData[0] || !rowData?.length || !isArray(res?.data?.data?.[0]) || (res?.data?.data?.[1] && !isArray(res?.data?.data?.[1]))){
                let errorArray; 
                if (isArray(res?.data?.data?.[0])){
                  const [first, ...restArray] = res?.data?.data || [];
                  errorArray = restArray;
                }else {
                  errorArray = res?.data?.data || []
                }
                const error = errorArray.map(e => {
                  return <div>{e}</div>;
                })
                setError(prev =>  {return {
                  ...prev,
                  compareSQLTemp : error?.length ? error : ''
                }})
                if (error?.length) setConfirmModal(true);
                dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading:false, isError: false}}));   
              }
              else {
                compareSqlHandler();
              }
            }
            else {
              showAlert({ mssg: res?.data?.message, isOpen: true, type: 'warning' });
            }
            dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading: false, isError: false}}));
          })
        }
      }
      else {
        dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading: false, isError: false}}));
        showAlert({ mssg: res?.data?.message, isOpen: true, type: 'warning' });
      }
      // dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading: false, isError: false}}));
    })
    // compareTimer.current = setTimeout(() => {
    //     dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isError: true}}));
    // }, 120000)
  }


  const compareSqlHandler = () => {
    if (error?.compareSQLTemp) setError(prev =>  {return {
      ...prev,
      compareSQL: prev?.compareSQLTemp || '',
      compareSQLTemp : ''
    }})
    else {
      setConnectionLoading(true);
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading: true, isError: false}}));
      dispatch(api.endpoints.compare_sql.initiate({
        body : {
          "templateSQL": templateQuery,
          "editedSQL"  : sqlQuery
        }
      },{forceRefetch : true}))
      .then( res => {
        if (res?.data?.current_state === "SUCCESS"){
          setConnectionLoading(false);
          setParseResult(res?.data?.data?.parseMsg);
          const resultArray = res?.data?.data?.result || [];
          const rowData = resultArray?.map( (e, i) => {
            const row = {id : i};
            e?.forEach((e, idx) => {
              row[compareSQLColumnDefs?.[idx + 1]?.field] = e;
            })
            row['checked'] = true;
            return row;
          });
          setRowData(prev => {return {...prev, compareSQL: rowData}});
        }
        else {
          showAlert({ mssg: res?.data?.message, isOpen: true, type: 'warning' });
        }
        dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading: false, isError: false}}));
      })
      .catch((res) => {
        setConnectionLoading(false);
        dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading: false, isError: false}}));
      })
    }
  }


  useEffect(() => {
    setPreviousSelectedTable({metaData: '', top25: ''})
    setSelectedMetaData([]);
    setGridOptions(prev => { return {...prev, metaData: {}, top25: {}, sqlResult: {}}})
    setRowData(prev => { return {metaData: [], top25: [], sqlResult: [], compareSQL: []} })
  }, [selectedTable]);


  useEffect(() => {
    if (currTab === 1){
      updateTop25DataHandler();
    }else if (currTab === 0){
      updateMetaDataHandler();
    }
  },[currTab, selectedTable])

  useEffect(() => {
    if (currTab === 1){
      updateTop25DataHandler(sort);
    }else if (currTab === 0){
      updateMetaDataHandler(sort);
    }
  },[sort])


  useEffect(() => {
    if (sqlActions?.runSqlScript) runSqlScript("runSqlScript");
    if (sqlActions?.runTemplateScript) runSqlScript("runTemplateScript");
    if (sqlActions?.compareSql) runCompareSql();
  },[sqlActions])


  useEffect(() => {
    const mssg = t('BOX_MSG_GENERAL_ERROR')
    if (metaError && metaLoading) {
      showAlert({ mssg, isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "META_LOADING", data: {isLoading: false, isError: false}}));
    }
    if (top25Error && top25Loading) {
      showAlert({ mssg, isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "TOP25_LOADING", data: {isLoading: false, isError: false}}));
    }
    if (sqlError && sqlLoading) {
      showAlert({ mssg,isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SQL_LOADING", data: {isLoading: false, isError: false}}));
    }
    if (compareError && compareLoading) {
      showAlert({ mssg,isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COMPARE_LOADING", data: {isLoading: false, isError: false}}));
    }
  },[metaError, top25Error, sqlError, compareError])


  return (
    <div  className="height-100">
        <Box sx={{ borderBottom: 1, borderColor: "divider", display: 'flex', justifyContent: 'space-between' }}>
          <Tabs onChange={handleTabChange} value={currTab}>
            <Tab
              disabled={metaLoading || top25Loading || sqlLoading || compareLoading}
              label={
                <div className="flex align-center">
                  <span className="flex align-center">
                    <span className="BALLOT screen-tab-icons"></span>
                    <span></span>
                    {t("DB_NAV_TAB_METADATA")}
                  </span>
                </div>
              }
            />
            <Tab
              disabled={metaLoading || top25Loading || sqlLoading || compareLoading}
              label={
                <div className="flex align-center">
                  <span className="flex align-center">
                    <span className="TABLE screen-tab-icons"></span>
                    <span>{t("DB_NAV_TAB_TOP25_RECS")}</span>
                  </span>
                </div>
              }
            />
            <Tab
              disabled={metaLoading || top25Loading || sqlLoading || compareLoading}
              label={
                <div className="flex align-center">
                  <span className="flex align-center">
                    <span className="FACT_CHECK screen-tab-icons"></span>
                    <span>{t("DB_NAV_TAB_SQL_RESULTS")}</span>
                  </span>
                </div>
              }
            />
            <Tab
              disabled={metaLoading || top25Loading || sqlLoading || compareLoading}
              label={
                <div className="flex align-center">
                  <span className="flex align-center">
                    <span className="EDIT_SQUARE screen-tab-icons"></span>
                    <span>{t("DB_NAV_TAB_COMPARE_SQL")}</span>
                  </span>
                </div>
              }
            />
            <Tab
              disabled={metaLoading || top25Loading || sqlLoading || compareLoading}
              label={
                <div className="flex align-center">
                  <span className="flex align-center">
                    <span className="HELP screen-tab-icons"></span>
                    <span>{t("DB_NAV_TAB_HELP")}</span>
                  </span>
                </div>
              }
            />
          </Tabs>
          {currTab === 0 ?<LightTooltip title={t('DB_NAV_ADD_SELECTED_FIELDS')}>
            <div><Button size="small" onClick={addFieldshandler} disabled={!selectedMetaData?.length}  variant="outlined">{t('ADD')}</Button></div>
          </LightTooltip>: ''}
        </Box>
        {currTab === 0 && (
          <TabPanel
            value={currTab}
            className={"height-100 overflow-auto"}
            index={0}
          >
            <Box sx={{position: 'relative'}} className={"height-100 overflow-auto"}>
              {metaLoading ? <Loader/> : Object.keys(gridOptions.metaData).length ? <CommonGrid
                gridOptions={{
                  ...gridOptions.metaData,
                  onSelectionChanged: metaGridSelectionHandler
                }}
                rowData={rowData.metaData}
                containerClasses="database-navigator-right-grid"
                gridProps={{
                  rowSelection: "multiple",
                  onRowDataUpdated: onRowDataUpdated
                }}
              /> : nothingToDisplay}
            </Box>
          </TabPanel>
        )}
        {currTab === 1 && (
          <TabPanel
            value={currTab}
            index={1}
            className={"height-100 overflow-auto"}
          >
            {top25Loading ? <Loader/> : Object.keys(gridOptions.top25).length ? <CommonGrid
              fullSize={false}
              gridOptions={gridOptions.top25}
              rowData={rowData.top25}
              containerClasses="database-navigator-right-grid"
            /> : nothingToDisplay}
          </TabPanel>
        )}
        {currTab === 2 && (
          <TabPanel
            value={currTab}
            index={2}
            className={"height-100 overflow-auto"}
          >
            {sqlLoading ? <Loader/> : error.sqlResult ? (
              <div className="error" style={{whiteSpace: "pre-wrap", padding:"10px",fontSize:'14px'}}> {error.sqlResult} </div> 
            ) : 
              (!rowData?.sqlResult?.length ? nothingToDisplay  : Object.keys(gridOptions.sqlResult).length && <CommonGrid
                fullSize={false}
                getGridAPI={(api, ref) => setSqlResultGridAPI(ref)}
                gridOptions={{
                  columnDefs : gridOptions?.sqlResult?.columnDefs?.length ? [...gridOptions?.sqlResult?.columnDefs] : []
                }}
                rowData={[...rowData.sqlResult]}
                containerClasses="database-navigator-right-grid"
              /> 
            )}
          </TabPanel>
        )}
        {currTab === 3 && (
          <TabPanel
            value={currTab}
            index={3}
            className={"height-100 overflow-auto"}
          >
            {compareLoading ? <Loader/> : error.compareSQL ? (
              <div className="error" style={{whiteSpace: "pre-wrap", padding:"10px",fontSize:'14px'}}> {error.compareSQL} </div>
            ) : (
              rowData?.compareSQL?.length ? <Box className={"height-100 overflow-auto"} sx={{display: 'flex', flexDirection: 'column', fontSize:'14px', }}>
                    <Box sx={{whiteSpace: "pre-wrap", padding:"10px",height: '30%', overflow: 'auto'}}>
                      {parseResult}
                    </Box>
                    <Box className="flex space-between border-container" sx={{alignItems: 'center',padding:'5px 10px', borderLeft:'none', borderRight: 'none'}}>
                      <span>{t('DB_NAV_PARSE_INSTRUCT')}</span>
                      <div className="flex" style={{gap: '5px'}}>
                        <Button size="small" onClick={()=>uncheckAllHandler(uncheckAll)} variant="outlined">
                          {t(uncheckAll ? 'DB_NAV_BTN_UNCHECK' : 'DB_NAV_BTN_CHECK')}
                        </Button>
                        <Button size="small" onClick={() => handleUpdate()} variant="outlined">
                          {t('DB_NAV_BTN_UPDATE')}
                        </Button>
                      </div>
                    </Box>
                    <Box  sx={{height: '58%', position: 'relative'}}>
                      <CommonGrid
                        gridOptions={gridOptions.compareSQL}
                        rowData={rowData.compareSQL}
                        getGridAPI={(api, ref) => setCompareSQLGridAPI(ref)}
                        gridProps={{
                          rowSelection: "multiple",
                          onSelectionChanged: compareSqlSelectHandler,
                          onRowDataUpdated : rowDataUpdatedCompareSQL 
                        }}
                        containerClasses="database-navigator-right-grid"
                      />
                    </Box>
              </Box> : nothingToDisplay
            )}
          </TabPanel>
        )}
        {currTab === 4 && (
          <TabPanel value={currTab} index={4} className={"height-100"}>
            <iframe
              style={{ border: "none", outline: "none" }}
              height={"100%"}
              width={"100%"}
              src={docpath}
            ></iframe>
          </TabPanel>
        )}
      <div></div>
      <ConfirmModal 
        message={t('DB_NAV_SQL_INVALID_PARSE_ANYWAY')} 
        openModal={confirmModal} 
        yesHandler={() => {
          compareSqlHandler()
          setConfirmModal(false);
        }} 
        noHandler={()=>setConfirmModal(false)} 
      />
    </div>
  );
};

export default DatabaseNavigatorRightBottom;




